import React from 'react'

import { Grid } from '@mui/material'

import NameToDomainForm from 'components/name-to-domain/NameToDomainForm'
import NameToDomainSearch from 'components/name-to-domain/NameToDomainSearch'

const NameToDomain = () => (
  <Grid container spacing={2}>
    <Grid
      size={{
        sm: 6,
      }}>
      <NameToDomainSearch />
    </Grid>
    <Grid
      size={{
        sm: 6,
      }}>
      <NameToDomainForm />
    </Grid>
  </Grid>
)

export default NameToDomain
